import { WhatsAppContact } from "@packages/chat-sdk";
import { Store } from "./store";
export interface WhatsAppContactsStoreType {
  selectedContact?: WhatsAppContact;
}

export const whatsappContactsStore = new Store<WhatsAppContactsStoreType>(
  () => ({
    selectedContact: undefined,
  })
);
export const whatsappContactsStoreActions = {
  setSelectedContact(payload?: WhatsAppContact) {
    whatsappContactsStore.set({
      selectedContact: payload,
    });
  },
};
